import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { ANSWER_TYPES } from '../interfaces/jobInterface';
import { DotSeparator } from './ui/DotSeparator';
import { QuestionDuration } from './ui/QuestionDuration';

interface IProps {
  answerType: `${ANSWER_TYPES}`;
  duration: number;
  takes?: number;
}

const QUESTION_TYPE_TEXT: { [K in ANSWER_TYPES]: () => string } = {
  [ANSWER_TYPES.VIDEO]: () => i18n.t('parameters_answer_type.video'),
  [ANSWER_TYPES.TEXT]: () => i18n.t('parameters_answer_type.text'),
  [ANSWER_TYPES.SINGLE]: () => i18n.t('parameters_answer_type.multi_choice'),
  [ANSWER_TYPES.MULTIPLE]: () => i18n.t('parameters_answer_type.multi_choice'),
};

export const QuestionParameters:React.FC<IProps> = ({ answerType, duration, takes }) => {
  const { t } = useTranslation();
  const assessmentParameter = QUESTION_TYPE_TEXT[answerType]();

  return (
    <div className="myinterview-widget-question__question-parameters myinterview-text--S color--neutral-40">
      <Text size="S-Regular" color="neutral-40">{assessmentParameter}</Text>
      <DotSeparator />
      <QuestionDuration duration={duration} />
      {takes && answerType === ANSWER_TYPES.VIDEO && (
        <>
          <DotSeparator />
          <Text size="S-Regular" color="neutral-40">
            {
          `${takes}
          ${t(
            'recorder.explanation.take',
            { count: takes },
          )}`
          }
          </Text>
        </>
      )}
    </div>
  );
};
